webpackJsonp([231608221292675],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(397),
	  options: { "plugins": [], "trackingId": "UA-70837381-2", "head": false, "anonymize": true, "respectDNT": true }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   {
	//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
	//     options: { ... },
	//   },
	//   {
	//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
	//     options: { ... },
	//   },
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== "undefined";
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _exports$json;
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-pages-about-us-js": __webpack_require__(337),
	  "component---src-pages-brand-design-a-b-js": __webpack_require__(338),
	  "component---src-pages-brand-design-behavioral-science-technologies-js": __webpack_require__(339),
	  "component---src-pages-brand-design-belly-art-js": __webpack_require__(340),
	  "component---src-pages-brand-design-birth-js": __webpack_require__(341),
	  "component---src-pages-brand-design-colony-square-js": __webpack_require__(342),
	  "component---src-pages-brand-design-east-works-js": __webpack_require__(343),
	  "component---src-pages-brand-design-fenton-js": __webpack_require__(344),
	  "component---src-pages-brand-design-high-street-js": __webpack_require__(345),
	  "component---src-pages-brand-design-literacy-for-all-js": __webpack_require__(346),
	  "component---src-pages-brand-design-lorelei-js": __webpack_require__(347),
	  "component---src-pages-brand-design-north-american-properties-js": __webpack_require__(348),
	  "component---src-pages-brand-design-oak-js": __webpack_require__(349),
	  "component---src-pages-brand-design-pennant-park-js": __webpack_require__(350),
	  "component---src-pages-brand-design-revel-js": __webpack_require__(351),
	  "component---src-pages-brand-design-riverton-js": __webpack_require__(352),
	  "component---src-pages-brand-design-sandy-springs-js": __webpack_require__(353),
	  "component---src-pages-brand-design-wilbert-js": __webpack_require__(354),
	  "component---src-pages-contact-js": __webpack_require__(355),
	  "component---src-pages-digital-realities-js": __webpack_require__(357),
	  "component---src-pages-digital-realities-ar-colony-square-js": __webpack_require__(356),
	  "component---src-pages-digital-realities-vr-250-williams-js": __webpack_require__(358),
	  "component---src-pages-digital-realities-vr-ac-hotel-js": __webpack_require__(359),
	  "component---src-pages-digital-realities-vr-alpharetta-conference-center-js": __webpack_require__(360),
	  "component---src-pages-digital-realities-vr-atlanta-financial-center-js": __webpack_require__(361),
	  "component---src-pages-digital-realities-vr-colony-square-js": __webpack_require__(362),
	  "component---src-pages-digital-realities-vr-hotel-avalon-js": __webpack_require__(363),
	  "component---src-pages-digital-realities-what-is-ar-js": __webpack_require__(364),
	  "component---src-pages-digital-realities-what-is-vr-js": __webpack_require__(365),
	  "component---src-pages-index-js": __webpack_require__(366)
	};
	
	exports.json = (_exports$json = {
	  "layout-index.json": __webpack_require__(5),
	  "about-us.json": __webpack_require__(367)
	}, _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-a-b.json"] = __webpack_require__(368), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-behavioral-science-technologies.json"] = __webpack_require__(369), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-belly-art.json"] = __webpack_require__(370), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-birth.json"] = __webpack_require__(371), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-colony-square.json"] = __webpack_require__(372), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-east-works.json"] = __webpack_require__(373), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-fenton.json"] = __webpack_require__(374), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-high-street.json"] = __webpack_require__(375), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-literacy-for-all.json"] = __webpack_require__(376), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-lorelei.json"] = __webpack_require__(377), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-north-american-properties.json"] = __webpack_require__(378), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-oak.json"] = __webpack_require__(379), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-pennant-park.json"] = __webpack_require__(380), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-revel.json"] = __webpack_require__(381), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-riverton.json"] = __webpack_require__(382), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-sandy-springs.json"] = __webpack_require__(383), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["brand-design-wilbert.json"] = __webpack_require__(384), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["contact.json"] = __webpack_require__(385), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities.json"] = __webpack_require__(386), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-ar-colony-square.json"] = __webpack_require__(387), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-250-williams.json"] = __webpack_require__(388), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-ac-hotel.json"] = __webpack_require__(389), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-alpharetta-conference-center.json"] = __webpack_require__(390), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-atlanta-financial-center.json"] = __webpack_require__(391), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-colony-square.json"] = __webpack_require__(392), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-vr-hotel-avalon.json"] = __webpack_require__(393), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-what-is-ar.json"] = __webpack_require__(394), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["digital-realities-what-is-vr.json"] = __webpack_require__(395), _exports$json["layout-index.json"] = __webpack_require__(5), _exports$json["index.json"] = __webpack_require__(396), _exports$json);
	
	exports.layouts = {
	  "layout---index": __webpack_require__(336)
	};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(130);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(58);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(76);
	
	var _shallowCompare = __webpack_require__(538);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // Set the pathname for 404 pages.
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, {
	        pathname: "/404.html"
	      });
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        var location = nextProps.location;
	
	        // Set the pathname for 404 pages.
	        if (!_loader2.default.getPage(location.pathname)) {
	          location = _extends({}, location, {
	            pathname: "/404.html"
	          });
	        }
	
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(location.pathname, function (pageResources) {
	          _this2.setState({
	            location: location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return (0, _shallowCompare2.default)(this, nextProps, nextState);
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(436);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(75);
	
	var _stripPrefix = __webpack_require__(131);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO add tests especially for handling prefixed links.
	var pageCache = {};
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = (0, _stripPrefix2.default)(pathname, pathPrefix);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(106);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(120678318354, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(404) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(255490432627201, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(405) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(253802935255996, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(406) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(251102506920145, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(407) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(280608832874753, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(408) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(43040732576999, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(409) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(23418452685258, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(410) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(161205263619399, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(411) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(14822362812536, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(412) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(50132571673065, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(413) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(75044597648265, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(414) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(106330415658958, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(415) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(277561393992458, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(416) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(70538755744003, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(417) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(111798988435522, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(418) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(279037372228884, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(419) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(252635422454166, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(420) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(98831230269852, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(421) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(184662623972074, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(422) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(139352004513106, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(423) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(89194616697835, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(424) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(97137152394724, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(425) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(135874017080475, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(426) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(273271489822485, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(427) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(259672565134947, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(428) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(220509110208154, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(429) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(143507134358403, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(430) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(70410770503386, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(431) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(125868233959201, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(432) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(433) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(109) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(200) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(198);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(58);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _stripPrefix = __webpack_require__(131);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var pathPrefix = "";
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	var fetchHistory = [];
	var failedPaths = {};
	var failedResources = {};
	var MAX_HISTORY = 5;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(201)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = void 0;
	    if (resourceName.slice(0, 12) === "component---") {
	      resourceFunction = asyncRequires.components[resourceName];
	    } else if (resourceName.slice(0, 9) === "layout---") {
	      resourceFunction = asyncRequires.layouts[resourceName];
	    } else {
	      resourceFunction = asyncRequires.json[resourceName];
	    }
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      fetchHistory.push({
	        resource: resourceName,
	        succeeded: !err
	      });
	
	      if (!failedResources[resourceName]) {
	        failedResources[resourceName] = err;
	      }
	
	      fetchHistory = fetchHistory.slice(-MAX_HISTORY);
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else if (failedResources[resourceName]) {
	    process.nextTick(function () {
	      cb(failedResources[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var appearsOnLine = function appearsOnLine() {
	  var isOnLine = navigator.onLine;
	  if (typeof isOnLine === "boolean") {
	    return isOnLine;
	  }
	
	  // If no navigator.onLine support assume onLine if any of last N fetches succeeded
	  var succeededFetch = fetchHistory.find(function (entry) {
	    return entry.succeeded;
	  });
	  return !!succeededFetch;
	};
	
	var handleResourceLoadError = function handleResourceLoadError(path, message) {
	  console.log(message);
	
	  if (!failedPaths[path]) {
	    failedPaths[path] = message;
	  }
	
	  if (appearsOnLine() && window.location.pathname.replace(/\/$/g, "") !== path.replace(/\/$/g, "")) {
	    window.location.pathname = path;
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	    pathPrefix = "";
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    if (true) {
	      if (false) pathPrefix = __PATH_PREFIX__;
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue() {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(rawPath) {
	    // Check page exists.
	    var path = (0, _stripPrefix2.default)(rawPath, pathPrefix);
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layout],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      if (failedPaths[path]) {
	        handleResourceLoadError(path, "Previously detected load failure for \"" + path + "\"");
	
	        return cb();
	      }
	
	      var _page = findPage(path);
	
	      if (!_page) {
	        handleResourceLoadError(path, "A page wasn't found for \"" + path + "\"");
	
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layout, function (err, l) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)))

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-pages-about-us-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"about-us.json","path":"/about-us/"},{"componentChunkName":"component---src-pages-brand-design-a-b-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-a-b.json","path":"/brand-design/a-b/"},{"componentChunkName":"component---src-pages-brand-design-behavioral-science-technologies-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-behavioral-science-technologies.json","path":"/brand-design/behavioral-science-technologies/"},{"componentChunkName":"component---src-pages-brand-design-belly-art-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-belly-art.json","path":"/brand-design/belly-art/"},{"componentChunkName":"component---src-pages-brand-design-birth-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-birth.json","path":"/brand-design/birth/"},{"componentChunkName":"component---src-pages-brand-design-colony-square-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-colony-square.json","path":"/brand-design/colony-square/"},{"componentChunkName":"component---src-pages-brand-design-east-works-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-east-works.json","path":"/brand-design/east-works/"},{"componentChunkName":"component---src-pages-brand-design-fenton-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-fenton.json","path":"/brand-design/fenton/"},{"componentChunkName":"component---src-pages-brand-design-high-street-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-high-street.json","path":"/brand-design/high-street/"},{"componentChunkName":"component---src-pages-brand-design-literacy-for-all-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-literacy-for-all.json","path":"/brand-design/literacy-for-all/"},{"componentChunkName":"component---src-pages-brand-design-lorelei-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-lorelei.json","path":"/brand-design/lorelei/"},{"componentChunkName":"component---src-pages-brand-design-north-american-properties-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-north-american-properties.json","path":"/brand-design/north-american-properties/"},{"componentChunkName":"component---src-pages-brand-design-oak-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-oak.json","path":"/brand-design/oak/"},{"componentChunkName":"component---src-pages-brand-design-pennant-park-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-pennant-park.json","path":"/brand-design/pennant-park/"},{"componentChunkName":"component---src-pages-brand-design-revel-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-revel.json","path":"/brand-design/revel/"},{"componentChunkName":"component---src-pages-brand-design-riverton-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-riverton.json","path":"/brand-design/riverton/"},{"componentChunkName":"component---src-pages-brand-design-sandy-springs-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-sandy-springs.json","path":"/brand-design/sandy-springs/"},{"componentChunkName":"component---src-pages-brand-design-wilbert-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"brand-design-wilbert.json","path":"/brand-design/wilbert/"},{"componentChunkName":"component---src-pages-contact-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"contact.json","path":"/contact/"},{"componentChunkName":"component---src-pages-digital-realities-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities.json","path":"/digital-realities/"},{"componentChunkName":"component---src-pages-digital-realities-ar-colony-square-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-ar-colony-square.json","path":"/digital-realities/ar_colony-square/"},{"componentChunkName":"component---src-pages-digital-realities-vr-250-williams-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-250-williams.json","path":"/digital-realities/vr_250-williams/"},{"componentChunkName":"component---src-pages-digital-realities-vr-ac-hotel-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-ac-hotel.json","path":"/digital-realities/vr_ac-hotel/"},{"componentChunkName":"component---src-pages-digital-realities-vr-alpharetta-conference-center-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-alpharetta-conference-center.json","path":"/digital-realities/vr_alpharetta-conference-center/"},{"componentChunkName":"component---src-pages-digital-realities-vr-atlanta-financial-center-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-atlanta-financial-center.json","path":"/digital-realities/vr_atlanta-financial-center/"},{"componentChunkName":"component---src-pages-digital-realities-vr-colony-square-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-colony-square.json","path":"/digital-realities/vr_colony-square/"},{"componentChunkName":"component---src-pages-digital-realities-vr-hotel-avalon-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-vr-hotel-avalon.json","path":"/digital-realities/vr_hotel-avalon/"},{"componentChunkName":"component---src-pages-digital-realities-what-is-ar-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-what-is-ar.json","path":"/digital-realities/what-is-ar/"},{"componentChunkName":"component---src-pages-digital-realities-what-is-vr-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"digital-realities-what-is-vr.json","path":"/digital-realities/what-is-vr/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"}]

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(76);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(165);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(75);
	
	var _gatsbyReactRouterScroll = __webpack_require__(401);
	
	var _domready = __webpack_require__(322);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(108);
	
	var _history2 = __webpack_require__(199);
	
	var _history3 = _interopRequireDefault(_history2);
	
	var _emitter = __webpack_require__(58);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(434);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(435);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(197);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(196);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(130);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(245);
	}
	
	window.___history = _history3.default;
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history3.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(202);
	  }
	
	  var navigateTo = function navigateTo(to) {
	    var location = (0, _history.createLocation)(to, null, null, _history3.default.location);
	    var pathname = location.pathname;
	
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	
	    // If we're already at this path, do nothing.
	    if (window.location.pathname === pathname) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(location);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(location);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(location);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history3.default.location,
	    action: _history3.default.action
	  });
	
	  var initialAttachDone = false;
	  function attachToHistory(history) {
	    if (!window.___history || initialAttachDone === false) {
	      window.___history = history;
	      initialAttachDone = true;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          // Make sure React has had a chance to flush to DOM first.
	          setTimeout(function () {
	            (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	          }, 0);
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history3.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history3.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(58);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	/**
	 * Remove a prefix from a string. Return the input string if the given prefix
	 * isn't found.
	 */
	
	exports.default = function (str) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	  if (str.substr(0, prefix.length) === prefix) return str.slice(prefix.length);
	  return str;
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.onRouteUpdate = function (_ref) {
	  var location = _ref.location;
	
	  // Don't track while developing.
	  if (("production") === "production" && typeof ga === "function") {
	    if (location && typeof window.excludeGAPaths !== "undefined" && window.excludeGAPaths.some(function (rx) {
	      return rx.test(location.pathname);
	    })) {
	      return;
	    }
	    window.ga("set", "page", location ? location.pathname + location.search + location.hash : undefined);
	    window.ga("send", "pageview");
	  }
	};

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(c,e){(n[c]||(n[c]=[])).push(e)},off:function(c,e){n[c]&&n[c].splice(n[c].indexOf(e)>>>0,1)},emit:function(c,e){(n[c]||[]).slice().map(function(n){n(e)}),(n["*"]||[]).slice().map(function(n){n(c,e)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Pulled from react-compat
	// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
	function shallowDiffers(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }return false;
	}
	
	exports.default = function (instance, nextProps, nextState) {
	  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(169928946856436, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(207) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(32821693624949, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(208) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(210488433442426, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(209) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(12853747426994, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(210) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(143323282344924, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(211) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(233577180853759, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(212) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(62064111756719, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(213) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(182143188611465, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(214) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(7880445870496, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(215) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(48473100346256, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(216) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(108732827543980, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(217) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(87196078665921, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(218) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(122556664745737, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(219) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(117359822503949, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(220) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(204842755036805, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(221) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(117131214989391, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(222) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(71710513853194, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(223) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(61650863323180, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(224) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(70144966829960, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(225) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(33451537186499, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(78) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(147575426612582, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(226) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(168919298432235, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(227) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(247624969173436, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(228) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(124548314766663, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(229) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(194455906138313, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(230) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(261421614623307, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(231) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(189532432117690, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(232) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(242216996668485, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(233) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(42896104772529, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(234) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(235) })
	        }
	      });
	     }
	    

/***/ })

});


// WEBPACK FOOTER //
// app-f6c69163a6224420bd80.js